var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArticleShortcutIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.33333 14.1667H11.6667V12.5H8.33333V14.1667ZM8.33333 10.8333H14.1667V9.16667H8.33333V10.8333ZM5.83333 7.5H14.1667V5.83333H5.83333V7.5ZM5.52083 18.3333C4.42361 18.3333 3.48958 17.9479 2.71875 17.1771C1.94792 16.4062 1.5625 15.4722 1.5625 14.375C1.5625 13.5833 1.76736 12.875 2.17708 12.25C2.58681 11.625 3.125 11.1528 3.79167 10.8333H1.66667V9.16667H6.66667V14.1667H5V12.1458C4.48611 12.2569 4.0625 12.5208 3.72917 12.9375C3.39583 13.3542 3.22917 13.8333 3.22917 14.375C3.22917 15.0139 3.45486 15.5556 3.90625 16C4.35764 16.4444 4.89583 16.6667 5.52083 16.6667V18.3333ZM8.33333 17.5V15.8333H15.8333V4.16667H4.16667V7.5H2.5V4.16667C2.5 3.70833 2.66319 3.31597 2.98958 2.98958C3.31597 2.66319 3.70833 2.5 4.16667 2.5H15.8333C16.2917 2.5 16.684 2.66319 17.0104 2.98958C17.3368 3.31597 17.5 3.70833 17.5 4.16667V15.8333C17.5 16.2917 17.3368 16.684 17.0104 17.0104C16.684 17.3368 16.2917 17.5 15.8333 17.5H8.33333Z",
    fill: "black",
    fillOpacity: 0.7
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArticleShortcutIcon);
export default __webpack_public_path__ + "static/media/article-shortcut-icon.09630676.svg";
export { ForwardRef as ReactComponent };